<section class="dt-overview" aria-label="Drivetrain fault detection capability">
  @if (title()) {
    <h3 class="dt-overview__title">{{ title() }}</h3>
  }
  @if (intro()) {
    <p class="dt-overview__intro">{{ intro() }}</p>
  }

  <div class="dt-legend">
    @for (item of legend(); track item.id ?? $index) {
      <div class="dt-legend-item">
        <div
          class="dt-legend-dot"
          [class]="'dt-legend-dot--' + item.level"
          aria-hidden="true"
        ></div>
        <span>{{ item.description }}</span>
      </div>
    }
  </div>

  <div class="dt-flow">
    @for (block of blocks(); track block.id ?? $index; let last = $last) {
      <div class="dt-block" [class.dt-block--active]="block.active">
        <div class="dt-block__head">
          <!-- h3 (not h4) so that the parent section's h2 → block-label
               sequence is valid heading-order without an h3 between them.
               When the optional dt-overview__title (also h3) is set the
               blocks become peers of the title — both are valid h2
               subsections; axe-core heading-order accepts h3, h3, h3, h3. -->
          <h3>{{ block.label }}</h3>
          <span>{{ block.badge }}</span>
        </div>
        <div class="dt-block__body">
          @if (block.subtitle) {
            <div class="dt-block__sub">{{ block.subtitle }}</div>
          }
          @for (fault of block.faults; track fault.id ?? $index) {
            <div
              class="dt-fault-row"
              [class.dt-fault-row--nm]="fault.level === 'not-monitored'"
              [attr.aria-label]="
                fault.name +
                ' — ' +
                (fault.level === 'not-monitored'
                  ? 'not monitored'
                  : fault.level + ' detection')
              "
            >
              <div
                class="dt-fault-dot"
                [class]="'dt-fault-dot--' + fault.level"
                aria-hidden="true"
              ></div>
              {{ fault.name }}
            </div>
          }
        </div>
      </div>
      @if (!last) {
        <div class="dt-arrow" aria-hidden="true">
          <svg viewBox="0 0 32 12" fill="none">
            <path
              d="M0 6h28m0 0l-6-5m6 5l-6 5"
              stroke="currentColor"
              stroke-width="1.5"
            />
          </svg>
        </div>
      }
    }
  </div>

  @if (callout()) {
    <p class="dt-callout">{{ callout() }}</p>
  }
</section>
